/**
 * @generated SignedSource<<152a987d2637f9a641ca5a5b95ea451d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutLayout_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerIncentives_viewer" | "CheckoutFooter_viewer" | "CheckoutHelp_viewer" | "CheckoutMobileSummaryPane_viewer" | "CheckoutSidebar_viewer" | "CheckoutSteps_viewer">;
  readonly " $fragmentType": "CheckoutLayout_viewer";
};
export type CheckoutLayout_viewer$key = {
  readonly " $data"?: CheckoutLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutLayout_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutLayout_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutMobileSummaryPane_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebar_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutFooter_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSteps_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutHelp_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerIncentives_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "59d2a34d06b471f94ba1c0c8bea46cfe";

export default node;
